import styled from 'styled-components';
import { Line } from '@ant-design/plots';

export const LineChart = styled(Line)``;
